import PropTypes from "prop-types";

import { KuvatIcon } from "src/components/icons/StepIcons";
import TilausTab_TabCell from "../../TabTilaus/components/TilausTab_TabCell";
import { useAttachmentsData } from "src/context/AttachmentsContext";
import { useEffect, useState } from "react";
import { showPumiFiAttachments } from "src/data/ifs/showIfs";
import pumiFiClass from "src/data/pumiFi/pumiFiClass";
import { useUserData } from "src/context/userContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useStepLogData } from "src/context/StepLogContext";

export default function KuvaTabText(props) {
  const { attachmentList, isLoaded: attachmentsIsLoaded } = useAttachmentsData();
  const isActive = props.isActive || false;
  const { keikkaData, isLoaded: keikkaDataIsLoaded } = useKeikkaData();
  const { stepLog } = useStepLogData();
  const { token } = useUserData();
  const [count, setCount] = useState(attachmentList?.length || 0);
  const [pumiFiAttachments, setPumiFiAttachments] = useState([]);

  useEffect(() => {
    if (!keikkaData && !keikkaDataIsLoaded) return;
    const asynk = async () => {
      const _pumiFi = showPumiFiAttachments(keikkaData, stepLog);
      if (!_pumiFi) return;
      let _pumiFi_kuvat = await pumiFiClass.getPumiFiAttachments(keikkaData.foreignKey, token);
      setPumiFiAttachments(_pumiFi_kuvat);
    };
    asynk();
  }, [keikkaData, stepLog, keikkaDataIsLoaded]);

  useEffect(() => {
    if (!attachmentsIsLoaded) return;
    setCount(attachmentList.length + pumiFiAttachments.length);
  }, [attachmentsIsLoaded, attachmentList, pumiFiAttachments]);

  return (
    <TilausTab_TabCell
      icon={<KuvatIcon className="tabIcon" />}
      title="Liitteet"
      subtitle={count + " kpl"}
      isLoading={!attachmentsIsLoaded || !keikkaDataIsLoaded}
      isActive={isActive}
      width={40}
    />
  );
}

KuvaTabText.propTypes = {
  isActive: PropTypes.bool,
};
